/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum TariffSection {
  GENERAL = 'general',
  ACCESSORIAL = 'accessorial',
  RATES = 'rates',
  MISCELLANEOUS = 'miscellaneous',
}
